import { type FC } from "react";
import { FormattedMessage } from "react-intl";
import { Box, Paper, Skeleton, styled } from "@mui/material";

import { useDownstreamMachines } from "@/hooks/machines";
import { FailedRetry } from "@/components/failed-retry";

import { ClosingMachineCard } from "./closing-machine-card";

const StyledBox = styled(Box)(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	flex: 1,
	overflow: "auto",
	gap: theme.spacing(2),
	backgroundColor: theme.palette.background.paper,
	borderRadius: theme.spacing(1),
	padding: theme.spacing(2),
	height: "100%",
}));

export const ClosingMachineContainer: FC = () => {
	const { machines, isLoading, error } = useDownstreamMachines();

	if (isLoading) {
		return (
			<Paper sx={{ display: "flex", flexDirection: "column", height: "100%", gap: 3, padding: 2 }}>
				<Skeleton variant="rectangular" height="50%" sx={{ borderRadius: (theme) => theme.spacing(1) }} />
				<Skeleton variant="rectangular" height="50%" sx={{ borderRadius: (theme) => theme.spacing(1) }} />
			</Paper>
		);
	}

	if (error) {
		return (
			<Paper>
				<FailedRetry retry={() => window.location.reload()} />
			</Paper>
		);
	}

	if (machines.length === 0) {
		return (
			<Paper sx={{ padding: 2 }}>
				<FormattedMessage id="No downstream machines available" defaultMessage="No downstream machines available" />
			</Paper>
		);
	}

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				gap: 2,
			}}
		>
			<StyledBox>
				{machines.map((machine) => (
					<ClosingMachineCard key={machine.id} machine={machine} />
				))}
			</StyledBox>
		</Box>
	);
};
